import { useEffect, useState, useRef } from "react";
import SharePopup from "./SharePopup";
import union from "../assets/icons/union.svg";
import shareIcon from "../assets/icons/share.svg";
import playIcon from "../assets/icons/video-play.svg";
import bottomBanner from "../assets/images/bottom-banner-web.png";

const ClubWonders = () => {
  const [videos, setVideos] = useState([]);
  const [active, setActive] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showSharePopup, setShowSharePopup] = useState(false);
  const autoPlayRef = useRef(null);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await fetch(
          "https://api.rss2json.com/v1/api.json?rss_url=https://www.youtube.com/feeds/videos.xml?channel_id=UCiCzK8JvuBSATbBa4FFaf7w"
        );
        const data = await response.json();

        if (data.items) {
          const videoData = data.items.slice(0, 3).map((item) => {
            const videoId = item.link.split("v=")[1] || item.guid.split("video:")[1];

            return {
              id: videoId,
              title: item.title,
              thumbnail: `https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`,
              videoUrl: `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&modestbranding=1&rel=0&iv_load_policy=3`,
              shareUrl: `https://www.youtube.com/watch?v=${videoId}`,
            };
          });

          if (videoData.length > 0) {
            setVideos(videoData);
          }
        }
      } catch (error) {
        console.error("Error fetching YouTube feed:", error);

        setVideos([
          { id: "1", title: "Loading...", thumbnail: "", videoUrl: "" },
        ]);
      }
    };

    fetchVideos();
  }, []);

  useEffect(() => {
    if (videos.length === 0 || isPlaying) return;

    autoPlayRef.current = setInterval(() => {
      setActive((prev) => (prev + 1) % videos.length);
    }, 5000);

    return () => {
      if (autoPlayRef.current) clearInterval(autoPlayRef.current);
    };
  }, [videos, isPlaying]);

  const handleManualSwitch = (index) => {
    setActive(index);
    setIsPlaying(false);
    if (autoPlayRef.current) clearInterval(autoPlayRef.current);
  };

  const currentVideo = videos[active];

  if (videos.length === 0) return null;

  return (
    <section
      id="club-wonders"
      className="container mx-auto relative w-full bg-cover bg-center mt-16 sm:mt-32 md:mt-36 lg:mt-40"
      style={{ backgroundImage: `url(${bottomBanner})` }}
    >
      <div className="flex justify-start h-10 md:h-16">
        <h2 className="flex items-center bg-white h-full px-2 md:px-6 text-lg md:text-2xl font-normal text-black">
          CLUB WONDERS
        </h2>
        <img src={union} alt="union" className="h-full w-auto" />
      </div>

      <div className="pb-4 md:pb-12">
        <div className="relative w-full aspect-video md:aspect-[21/9] bg-black overflow-hidden shadow-2xl group flex flex-col">

          <div className="relative flex-grow w-full h-full">
            {!isPlaying ? (
              <>
                <div
                  className="absolute inset-0 bg-cover bg-center transition-all duration-500"
                  style={{ backgroundImage: `url(${currentVideo?.thumbnail})` }}
                >
                  <div className="absolute inset-0 bg-black/30"></div>
                </div>

                <button
                  onClick={() => setIsPlaying(true)}
                  className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20 hover:scale-110 transition-transform duration-300 cursor-pointer"
                >
                  <img src={playIcon} alt="play" className="w-12 h-12 md:w-20 md:h-20" />
                </button>
              </>
            ) : (
              <iframe
                src={currentVideo?.videoUrl}
                title={currentVideo?.title}
                className="w-full h-full absolute inset-0 z-10"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            )}
          </div>

          <div className={`absolute bottom-0 left-0 w-full z-40 flex justify-between items-center py-1 md:py-2 px-6 bg-[#0C0C0C26] ${isPlaying ? "pointer-events-none" : ""}`}>
            <div />
            {!isPlaying && (
              <h3 className="text-white text-lg font-normal font-malayalam truncate max-w-md md:max-w-2xl text-center">
                {currentVideo?.title}
              </h3>
            )}
            <div />
          </div>

          <div className={`absolute right-4 md:right-8 bottom-10 md:bottom-16 lg:bottom-24 xl:bottom-32 z-50 flex flex-col items-center gap-3 lg:gap-6 ${isPlaying ? "pointer-events-none" : ""}`}>
            <div className={`relative hidden md:flex mb-4 lg:mb-8 ${isPlaying ? "pointer-events-auto" : ""}`}>
              {showSharePopup && (
                <>
                  <div
                    className="fixed inset-0 z-40"
                    onClick={() => setShowSharePopup(false)}
                  />
                  <SharePopup
                    videoUrl={currentVideo?.shareUrl || window.location.href}
                    title={currentVideo?.title || "Check out this video!"}
                    onClose={() => setShowSharePopup(false)}
                  />
                </>
              )}
              <button
                onClick={() => setShowSharePopup(!showSharePopup)}
                className="flex items-center justify-center w-12 h-12 lg:w-14 lg:h-14 hover:bg-white/10 rounded-full transition-colors relative z-50 bg-black/40"
              >
                <img src={shareIcon} alt="share" className="w-6 h-6 lg:w-7 lg:h-7" />
              </button>
            </div>

            <div className="flex flex-col gap-1 md:gap-4">
              {videos.map((_, index) => (
                <button
                  key={index}
                  onClick={() => handleManualSwitch(index)}
                  className={`flex items-center gap-1 md:gap-3 group/btn ${isPlaying ? "pointer-events-auto" : ""}`}
                >
                  <div
                    className={`w-3 h-3 transition-colors duration-300 ${active === index ? "bg-white" : "bg-[#757575]"
                      }`}
                  ></div>
                  <span
                    className={`text-sm font-bold transition-colors duration-300 ${active === index ? "text-white" : "text-[#757575]"
                      }`}
                  >
                    0{index + 1}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClubWonders;
